import { render, staticRenderFns } from "./BoardDetail.vue?vue&type=template&id=196e5384&scoped=true&"
import script from "./BoardDetail.vue?vue&type=script&lang=js&"
export * from "./BoardDetail.vue?vue&type=script&lang=js&"
import style0 from "./BoardDetail.vue?vue&type=style&index=0&id=196e5384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196e5384",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
